<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.67 30.14"
  >
    <path
      class="cls-1"
      d="M16.67,15.07s0-.03,0-.04c-.01-.4-.16-.79-.46-1.09L2.73.47c-.62-.62-1.64-.62-2.26,0s-.62,1.64,0,2.26l12.34,12.34L.47,27.41c-.62.62-.62,1.64,0,2.26.31.31.72.47,1.13.47s.82-.16,1.13-.47l13.47-13.47c.3-.3.45-.69.46-1.09,0-.01,0-.03,0-.04Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
